import { render, staticRenderFns } from "./TradeFee.vue?vue&type=template&id=cc0b58d8&scoped=true&"
import script from "./TradeFee.vue?vue&type=script&lang=js&"
export * from "./TradeFee.vue?vue&type=script&lang=js&"
import style0 from "./TradeFee.vue?vue&type=style&index=0&id=cc0b58d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b58d8",
  null
  
)

export default component.exports